import { isNullOrUndefined, objectHasKeys } from '@/utils/comparators'
import { isEmpty } from '@/utils/array'

/**
* Returns true if the user has made a payment
*/
const hasPaid = (state) => {
  return !isNullOrUndefined(state.paymentCount) ? state.paymentCount > 0 : false
}

/**
* Returns true if the user has made zero payments before
*/
const isFirstPayment = (state) => {
  return !isNullOrUndefined(state.paymentCount) ? state.paymentCount === 0 : false
}

/**
* Returns true if the user has made one payment before
*/
const isSecondPayment = (state) => {
  return !isNullOrUndefined(state.paymentCount) ? state.paymentCount === 1 : false
}

/**
* List with iso-alpha-2 country codes to destinations where the user has called
*/
const calledCountries = (state) => {
  return objectHasKeys(state.calledCountries)
    ? Object.keys(state.calledCountries)
    : []
}

/**
* Returns true if the user has made a call to specified country
* * @param {string} id
*/
const hasCalledCountry = (state) => (id) => {
  let countries = objectHasKeys(state.calledCountries)
    ? Object.keys(state.calledCountries)
    : []
  let filtered = countries.filter((b) => b.toUpperCase() === id.toUpperCase())
  return !isEmpty(filtered)
}

export default {
  hasPaid,
  isFirstPayment,
  isSecondPayment,
  calledCountries,
  hasCalledCountry
}



// WEBPACK FOOTER //
// ./src/store/modules/user/statistics/getters.js